module.exports = __webpack_public_path__ + "static/star-schema-fdf3f0f7bd78e9d5bddd0a505189796a.png";